
import {finalize} from 'rxjs/operators';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Dialog } from '../../ui/dialog/dialog';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { DLCompany } from './company';
import { DLCompanyService, DLCompanyFilter } from './company.service';
import { NotifierService } from '../../ui/alert/notifier.service';

import { filter as lodashFilter, size } from 'lodash';

const FILTER_KEY = 'companies.search-filter';

/**
 * Entity filter dialog
 */
@Component({
  templateUrl: './company-search-dialog.component.html',
  host: {'(window:keydown)': 'hotkeys($event)'},
  styles: [
    `.dialog-container {
      display: block;
      position: fixed;
      z-index: 300;
      width: 100%;
      left: 0;
    }`
  ],
  animations: [
    trigger(
      'openState',
      [
        state(
          'open',
          style({
            top: '0px'
          })
        ),
        state(
          'closed',
          style({
            top: '-136px'
          })
        ),
        transition('closed => open', animate('400ms ease-out')),
        transition('open => closed', animate('400ms ease-in')),
      ]
    ),
  ]
})
export class DLCompanySearchDialogComponent implements Dialog, OnInit {
  state = 'closed';

  search: string
  hideId: string

  lastSearch: string
  searchTimer: any

  @ViewChild('searchInput')
  searchInput: ElementRef

  companies: DLCompany[]
  selectedItem: DLCompany
  
  onClose: () => void
  onSelect: (company: DLCompany) => void

  constructor(
    private companyService: DLCompanyService,
    private notifier: NotifierService,
  ) {

  }

  ngOnInit() {
    if(!this.search) {

      // Load filter from localStorage
      if(window.localStorage) {
        try {
          this.search = window.localStorage.getItem(FILTER_KEY);
        }
        catch(err) {}
      }
      
      if(!this.search) {
        this.search = '';
      }
    }

    this.lastSearch = this.search;

    this.apply();

    // Focus search input
    this.searchInput.nativeElement.focus();
  }

  close() {
    this.onClose();
  }

  select(company: DLCompany) {
    this.onSelect(company);
  }

  apply() {
    let filter = new DLCompanyFilter();
    filter.search = this.search;
    filter.offset = 0;
    filter.limit = 10;
    filter.orderBy = 'NAME';
    filter.orderDir = 'ASC';

    this.notifier.startProgress();

    this.companyService
      .companies(filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        if(this.hideId) {
          this.companies = lodashFilter(result.companies, company => {
            return company.id !== this.hideId;
          });
        }
        else {
          this.companies = result.companies;
        }

        if(size(this.companies) > 0) {
          this.selectedItem = this.companies[0];
        }
      });

    // Save filter to localStorage
    if(window.localStorage) {
      window.localStorage.setItem(FILTER_KEY, this.search);
    }
  }

  hotkeys(event: KeyboardEvent){
    
    switch(event.keyCode) {
      // Escape key
      case 27:
        this.close();
        break;
      // Enter key
      case 13:
        if(size(this.companies) && this.selectedItem) {
          this.select(this.selectedItem);
        }
        event.preventDefault();
        return false;
      // Up Arrow key
      case 38:
        if(size(this.companies) > 0) {
          let selectedIndex = this.companies.indexOf(this.selectedItem);

          if(selectedIndex >= 0) {
            selectedIndex -= 1;

            if(selectedIndex >= 0) {
              this.selectedItem = this.companies[selectedIndex];
            }
          }
        }
        break;
      // Down Arrow key
      case 40:
        if(size(this.companies) > 0) {
          let selectedIndex = this.companies.indexOf(this.selectedItem);

          if(selectedIndex >= 0) {
            selectedIndex += 1;

            if(selectedIndex < this.companies.length) {
              this.selectedItem = this.companies[selectedIndex];
            }
          }
        }
        break;
    }
  }

  searchKeyup(event: KeyboardEvent) {
    if(this.lastSearch !== this.search) {
      this.lastSearch = this.search;

      if(this.searchTimer) {
        window.clearTimeout(this.searchTimer);
      }

      this.searchTimer = window.setTimeout(() => {
        this.apply();
      }, 500);
    }
  }
}

